import { render, staticRenderFns } from "./CollectMoney.vue?vue&type=template&id=7b200e08&scoped=true&"
import script from "./CollectMoney.vue?vue&type=script&lang=js&"
export * from "./CollectMoney.vue?vue&type=script&lang=js&"
import style0 from "./CollectMoney.vue?vue&type=style&index=0&id=7b200e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b200e08",
  null
  
)

export default component.exports